{
  "appName": "Oasis Explorer",
  "account": {
    "cantLoadDetails": "Unfortunately we couldn't load the account details at this time. Please try again later.",
    "emptyTokenList": "This account holds no {{spec}} {{description}}.",
    "emptyTransactionList": "There are no transactions on record for this account.",
    "emptyTokenTransferList": "There are no token transfers on record for this account.",
    "ERC20": "ERC-20",
    "ERC721": "ERC-721",
    "noTokens": "This account holds no tokens",
    "showMore": "+ {{counter}} more",
    "title": "Account",
    "transactionsListTitle": "Account Transactions",
    "totalReceived": "Total Received",
    "totalSent": "Total Sent"
  },
  "activeAccounts": {
    "title": "Active Accounts",
    "tooltip": "{{value, number}} accounts"
  },
  "blocks": {
    "latest": "Latest Blocks"
  },
  "block": {
    "gasUsed": "{{value, number}} | {{percentage, number}}"
  },
  "banner": {
    "buildStaging": "Please note this is an internal launch meant to gather your feedback.",
    "buildPreview": "Please note this is an experimental build of Oasis Explorer and that data that is shown might be incorrect."
  },
  "clipboard": {
    "label": "Copy to clipboard",
    "success": "Copied!"
  },
  "coinGeckoReferral": "Data from <CoinGeckoLink>CoinGecko</CoinGeckoLink>",
  "common": {
    "address": "Address",
    "age": "Age",
    "balance": "Balance",
    "block": "Block",
    "bytes": "{{value, number}}",
    "cancel": "Cancel",
    "copy": "Copy",
    "data": "Data",
    "emerald": "Emerald",
    "cipher": "Cipher",
    "consensus": "Consensus",
    "eth": "ETH",
    "events": "Events",
    "failed": "Failed",
    "fiatValue": "Fiat Value",
    "fiatValueInUSD": "{{value, currency}}",
    "fill": "Fill",
    "formattedBlockTimestamp": "{{timestamp, dateTime}} ({{distance}})",
    "formattedDateTime": "{{timestamp, dateTime}}",
    "from": "From",
    "gasUsed": "Gas Used",
    "gasLimit": "Gas Limit",
    "hash": "Hash",
    "height": "Height",
    "hide": "Hide",
    "loadMore": "Load more",
    "lessThanAmount": "&lt; {{value, number}} <TickerLink />",
    "missing": "n/a",
    "name": "Name",
    "nft": "NFT",
    "nfts": "NFTs",
    "not_defined": "Not defined",
    "oasis": "Oasis",
    "paratime": "Paratime",
    "parentheses":"({{subject}})",
    "percentage": "Percentage",
    "rank": "Rank",
    "select": "Select",
    "size": "Size",
    "sapphire": "Sapphire",
    "show": "Show",
    "smartContract": "Smart Contract",
    "smartContract_short": "Contract",
    "success": "Success",
    "status": "Status",
    "ticker": "Ticker",
    "timestamp": "Timestamp",
    "to": "To",
    "token": "Token",
    "tokenInstance": "TokenID [<InstanceLink />] <TickerLink/>",
    "tokens": "Tokens",
    "transactions": "Transactions",
    "transactionAbbreviation": "Txs",
    "transactionFee": "Transaction Fee",
    "type": "Type",
    "quantity": "Quantity",
    "unknown": "Unknown",
    "value": "Value",
    "valueLong": "{{value, number}}",
    "valueInToken": "{{value, number}} {{ticker}}",
    "roundedValueInToken": "{{value, number}}… <TickerLink />",
    "valueInTokenWithLink": "{{value, number}} <TickerLink />",
    "view": "View",
    "viewAll": "View all",
    "paraTimeOnline": "ParaTime Online",
    "paraTimeOutOfDate": "ParaTime Out of date",
    "mainnet": "Mainnet",
    "testnet": "Testnet",
    "valuePair": "{{value, number}}"
  },
  "contract": {
    "code": "Code",
    "copyButton": "Copy {{subject}}",
    "creationByteCode": "Creation ByteCode",
    "creator": "Creator",
    "createdAt": "at <TransactionLink>",
    "noCode": "There is no bytecode on record for this account. (Are you sure this is a contract?)",
    "title": "Contract",
    "runtimeByteCode": "Runtime ByteCode",
    "verification": {
      "title": "Verification",
      "isVerified": "Verified",
      "isNotVerified": "Unverified",
      "openInSourcify": "Open in <SourcifyLink>Sourcify</SourcifyLink>",
      "verifyInSourcify": "Verify through <SourcifyLink>Sourcify</SourcifyLink>"
    }
  },
  "nodes": {
    "title": "Active nodes",
    "unknown": "Consensus layer indexer is not caught up with the latest blocks. The number of active nodes is unknown.",
    "tooltip": "Blockchain nodes are authorized devices that track the distributed ledger and serve as communication hubs in the network.",
    "value": "{{value, number}}"
  },
  "errors": {
    "code": "error code",
    "error": "Error",
    "loadFirstPage": "load the first page",
    "unknown": "Unknown error",
    "unsupportedLayer": "Unsupported layer",
    "unsupportedNetwork": "Unsupported network",
    "invalidAddress": "Invalid address",
    "invalidBlockHeight": "Invalid block height",
    "invalidPageNumber": "Invalid page number",
    "invalidTxHash": "Invalid transaction hash",
    "notFoundBlockHeight": "Block not found",
    "notFoundTx": "Transaction not found",
    "pageDoesNotExist": "The page you are looking for does not exist.",
    "validateURL": "Please validate provided URL",
    "validateURLOrGoToFirstPage": "Please check the URL or <FirstPageLink />.",
    "invalidUrl": "Invalid URL",
    "storage": "Access to browser storage denied"
  },
  "footer": {
    "mobileTitle": "OPF",
    "title": "Oasis Protocol Foundation",
    "version": "Version: <ReleaseLink>{{version}}</ReleaseLink> (commit: <CommitLink>{{sha}}</CommitLink>) built at {{buildTime}}",
    "apiDocs": "API Documentation",
    "github": "GitHub"
  },
  "learningMaterials": {
    "emerald": {
      "header": "What is the Emerald network?",
      "description": "The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility."
    },
    "sapphire": {
      "header": "What is the Sapphire network?",
      "description": "The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    },
    "header": "Learning materials",
    "hardhat": {
      "header": "Add the {{ layer }} Testnet to Hardhat",
      "description": "Open up your hardhat.config.ts and drop in these lines."
    },
    "token": {
      "header": "Token Metrics and Distribution",
      "description": "Rose is the currency powering the Oasis network."
    },
    "testnet": {
      "header": "Testnet parameters",
      "description": "The Testnet may be subject to frequent version upgrades."
    },
    "transfer": {
      "header": "How to Transfer ROSE into a ParaTime?",
      "description": "Rose is the currency powering the {{layer}} network."
    }
  },
  "pageTitle": "Oasis Explorer",
  "pageHeader": {
    "ribbon": "You are viewing {{network}} data"
  },
  "pagination": {
    "first": "First",
    "last": "Last"
  },
  "rosePrice": {
    "header": "ROSE Price"
  },
  "social": {
    "description": "Be part of the community and stay in the loop on everything Oasis",
    "discord": "Discord",
    "header": "Join us",
    "reddit": "Reddit",
    "telegram": "Telegram",
    "twitter": "Twitter",
    "youtube": "Youtube"
  },
  "tableLayoutButton": {
    "changeView": "Change view"
  },
  "testnetFaucet": {
    "description": "Drops are limited to 10 TEST tokens",
    "header": "Oasis Testnet Faucet",
    "request": "Request test tokens"
  },
  "tokens": {
    "typeDescription": "{{description}} ({{spec}})",
    "emptyTokenHolderList": "There are no token holders on record for this token.",
    "holders": "Token Holders",
    "holdersValue": "{{ value, number }}",
    "holdersCount": "Holders Count",
    "holdersCount_short": "Holders",
    "totalSupply": "Total Supply",
    "totalSupplyValue": "{{ value, number }}",
    "transfers": "Token Transfers",
    "transferEventType": {
      "transfer": "Transfer",
      "approval": "Approval",
      "minting": "Minting",
      "burning": "Burning",
      "unavailable": "Unknown token transfer event",
      "unknown": "Unknown: {{name}}"
    },
    "type": "Token Type"
  },
  "tokenSnapshot": {
    "header": "Token Snapshot"
  },
  "totalTransactions": {
    "header": "Total Transactions",
    "tooltip": "{{value, number}} total transactions",
    "value": "{{value, number}}"
  },
  "transactions": {
    "encryption": {
      "dataNonce": "Data Nonce",
      "encryptedData": "Data (encrypted)",
      "encryptedResult": "Result (encrypted)",
      "format": "Format",
      "publicKey": "Public Key",
      "resultNonce": "Result Nonce"
    },
    "latest": "Latest Transactions",
    "method": {
      "unavailable": "Malformed transaction, method unavailable",
      "unknown": "Unknown: {{method}}",
      "accounts": {
        "transfer": "Transfer"
      },
      "consensus": {
        "deposit": "Consensus Deposit",
        "withdraw": "Consensus Withdraw"
      },
      "evm": {
        "call": "Contract Call",
        "create": "Contract Creation"
      }
    }
  },
  "transaction": {
    "header": "Transaction",
    "warningMultipleTransactionsSameHash": "Please make sure you're looking at the right transaction. There is more than one transaction with this hash, which is extremely rare. We are showing the most recent successful one.",
    "tooltips": {
      "txTooltipEth": "Ethereum hash for the transaction",
      "senderTooltipEth": "Ethereum address for the sender",
      "recipientTooltipEth": "Ethereum address for the recipient",
      "txTooltipOasis": "Oasis hash for the transaction",
      "senderTooltipOasis": "Oasis address for the sender",
      "recipientTooltipOasis": "Oasis address for the recipient",
      "txTooltipHashUnavailable": "Hash not available in selected address format",
      "txEncrypted": "This transaction is encrypted.",
      "txNotEncrypted": "This transaction is <strong>not</strong> encrypted.",
      "senderTooltipUnavailable": "Sender not available in selected address format",
      "recipientTooltipUnavailable": "Recipient not available in selected address format"
    }
  },
  "transactionEvent": {
    "cantLoadEvents": "Unfortunately we couldn't load the list of events. Please try again later.",
    "accountsburn": "Tokens burnt",
    "accountsmint": "Tokens minted",
    "accountstransfer": "Transfer",
    "consensusDeposit": "Deposit from consensus",
    "consensusWithdrawal": "Withdrawal to consensus",
    "evmLog": "EVM log message",
    "gasUsed": "Gas used",
    "fields": {
      "amount": "Amount",
      "owner": "Owner"
    }
  },
  "transactionStats": {
    "header": "Transactions Per Day",
    "perDay": "{{value}} tx/day",
    "perHour": "{{value}} tx/hour"
  },
  "select": {
    "placeholder": "Select"
  },
  "chartDuration": {
    "pastDay": "Past day",
    "pastWeek": "Past week",
    "pastMonth": "Past month",
    "allTime": "All time",
    "week": "Week",
    "month": "Month",
    "lastHour": "Last hour",
    "lastDay": "Last day",
    "lastMonth": "Last month"
  },
  "currentFiatValue": {
    "title": "Current fiat value",
    "explanation": "This figure is calculated using the current rate. The value at the time of transaction might have been different."
  },
  "paraTimeSnapshot": {
    "header": "{{ paratime }} Snapshot"
  },
  "paraTimePicker": {
    "chainId": "Chain ID:",
    "decimal": "Decimal: {{ id }}",
    "comingSoonTitle": "Coming soon",
    "comingSoonLabel": "(coming soon)",
    "goToDashboard": "Go to dashboard",
    "hex": "Hex: {{ id }}",
    "less": "Show Less",
    "more": "Show More",
    "readMore": "Read more about {{ layer }} on {{ network }} in Oasis Docs",
    "rpcHttp": "RPC HTTP endpoint: {{ endpoint }}",
    "rpcWebSockets": "RPC WebSockets endpoint: {{ endpoint }}",
    "selected": "(active)",
    "viewNetworks": "View Networks",
    "viewParaTimes": "View ParaTimes",
    "mainnet": {
      "emerald": "The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility.",
      "sapphire": "The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    },
    "testnet": {
      "emerald": "The Testnet of the EVM Compatible ParaTime providing a smart contract development environment.",
      "sapphire": "The Testnet of the official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."
    }
  },
  "home": {
    "apiOffline": "Our {{ target }} API is offline. We’re trying to reconnect",
    "userOffline": "You are offline. We’re trying to reconnect",
    "runtimeOutOfDate": "We don't have fully up-to-date data about our {{ target }}. The data displayed here might be out of date.",
    "runtimeUnavailable": "Data about {{ target }} is currently not available. Please check back later.",
    "runtimeOutOfDateSince": "The last update we have about our {{ target }} is from {{ lastUpdate }}. The data displayed here might be out of date.",
    "blocks": "Blocks",
    "exploreBtnText": "Explore Oasis",
    "txns": "Txns",
    "zoomOutBtnText": "Zoom out",
    "online": "Online",
    "offline": "Offline",
    "helpScreen": {
      "navigate": "Navigate using your finger",
      "pinch": "Pinch to zoom in and out",
      "tap": "Tap to view info",
      "getStarted": "Get Started",
      "infoIconAria": "Toggle info screen"
    },
    "tooltip": {
      "coming": "Coming soon",
      "openParatime": "Open ParaTime",
      "sapphireParaTimeDesc": "Confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility",
      "emeraldParaTimeDesc": "EVM Compatible ParaTime providing smart contract environment with EVM compatibility.",
      "cipherParaTimeDesc": "The Cipher ParaTime is a Confidential ParaTime for executing Wasm smart contracts.",
      "consensusDesc": "Our scalable, high-throughput, secure, proof-of-stake consensus layer run by a decentralized set of validator nodes.",
      "close": "Close"
    },
    "selectedNetwork": "Selected network",
    "coming": "Coming",
    "soon": "soon"
  },
  "search": {
    "placeholder": "Address, Block, Contract, Transaction hash, Token name, etc.",
    "error": {
      "tooShort": "Please enter either at least 3 characters or a number in order to perform a search.",
      "privacy": "It seems like you might accidentally entered a keyphrase for a wallet. Please note that your mnemonic is a secret key that should never be shared, even not with our {{ appName }}.\nExecuting this search is highly unlikely to return any results. If you want to proceed nonetheless, please add “{{ wordsOfPower }}” in front of your search query to perform the search at your own risk."
    },
    "mobilePlaceholder": "Search Address, Block, Txn, Token, etc",
    "noResults": {
      "header": "No results found",
      "scopeHeader": "No results found on {{scope}}",
      "description": "Please try another search query <OptionalBreak>or <HomeLink>explore Oasis</HomeLink></OptionalBreak>"
    },
    "otherResults": {
      "clickToShowThem": "We found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.",
      "clickToShowMore": "We also found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.",
      "clickToHide": "The results from other <strong>Networks</strong> are shown below. Click to hide those results."
    },
    "results": {
      "accounts": {
        "title": "Accounts",
        "viewLink": "View Account"
      },
      "blocks": {
        "title": "Blocks",
        "viewLink": "View Block"
      },
      "contracts": {
        "title": "Contracts",
        "viewLink": "View Contract"
      },
      "tokens": {
        "title": "Tokens",
        "viewLink": "View Token"
      },
      "transactions": {
        "title": "Transactions",
        "viewLink": "View Transaction"
      },
      "count_one": "1 result",
      "count_other": "{{ count }} results",
      "moreCount_one": "1 more result",
      "moreCount_other": "{{ count }} more results"
    },
    "searchBtnText": "Search",
    "searchSuggestions": "Not sure what to look for? Try out a search: <OptionalBreak><BlockLink><BlockIcon/> Block</BlockLink>, <TransactionLink><TransactionIcon/> Transaction</TransactionLink>, <AccountLink><AccountIcon/> Address</AccountLink>, <TokenLink><TokenIcon/> Token</TokenLink> </OptionalBreak>.",
    "wordsOfPower": "I COMMAND THEE TO SEARCH FOR"
  }
}
